export function clearContextSession() {
  localStorage.removeItem("ngStorage-session");
}

export function getContextSession() {
  const rawValue = localStorage.getItem("ngStorage-session") ?? "";
  return rawValue.replace(/"/g, "").trim();
}

/** Login state that returns the user to their current page, skipping unproductive paths */
export function getLoginState(pathname: string, search: string) {
  if (pathname === "/" || pathname === "/logout") {
    return undefined;
  }
  return { redirectTo: encodeURIComponent(pathname + search) };
}
